export enum AlignPositions {
    INITIAL = 'inherit',
    LEFT = 'left',
    CENTER = 'center',
    RIGHT = 'right',
    JUSTIFY = 'justify'
}
